import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: '40%',
    minWidth: '576px',
    padding: `${theme.spacing(3)}px ${theme.spacing(4)}px`,
    // The paper is height:100% of the viewport, and this padding was being added OUTSIDE
    // that height — making the panel 48px taller than the window. The content then fitted
    // inside the oversized panel, so scrollHeight === clientHeight and `overflow-y: auto`
    // had nothing to scroll: whatever sat in the bottom 48px was simply off-screen and
    // unreachable. Counting the padding inside the height makes the panel match the window,
    // so content taller than it scrolls as it should. [QW-326]
    boxSizing: 'border-box',
    '&.dense': {
      padding: 0,
    },
    '&.wide': {
      width: '55.5%',
    },
    '&.large': {
      width: '63%',
    },
    '&.xlarge': {
      width: '72%',
    },
    '&.fullWidth': {
      width: '95%',
    },
  },
}));

export default useStyles;
